import React, { useState } from 'react';

function NumberPage(props) {
  const [number, setNumber] = useState(0);
  const [mathInfo, setMathInfo] = useState('');
  const [triviaInfo, setTriviaInfo] = useState('');
  const [dateInfo, setDateInfo] = useState(Array(31).fill(''));
  const [yearInfo, setYearInfo] = useState('');
  const [monthInfo, setMonthInfo] = useState(Array(12).fill(''));

  const initState = () => {
    setMathInfo('');
    setTriviaInfo('');
    setDateInfo(Array(31).fill(''));
    setYearInfo('');
    setMonthInfo(Array(12).fill(''));
  };

  const handleOnKeyUp = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    initState();

    fetch(`http://numbersapi.com/${number}`, { method: 'GET' })
      .then((response) => {
        response.text().then((data) => {
          setTriviaInfo(data);
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`http://numbersapi.com/${number}/math`, { method: 'GET' })
      .then((response) => {
        response.text().then((data) => {
          setMathInfo(data);
        });
      })
      .catch((error) => {
        console.log(error);
      });

    if (number > 0) {
      fetch(`http://numbersapi.com/${number}/year`, { method: 'GET' })
        .then((response) => {
          response.text().then((data) => {
            setYearInfo(data);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (number >= 1 && number <= 12) {
      for (let i = 1; i <= 31; i++) {
        fetch(`http://numbersapi.com/${number}/${i}/date`, { method: 'GET' })
          .then((response) => {
            response.text().then((data) => {
              monthInfo[i - 1] = data;
              setMonthInfo([...monthInfo]);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }

    if (number >= 1 && number <= 31) {
      for (let i = 1; i <= 12; i++) {
        fetch(`http://numbersapi.com/${i}/${number}/date`, { method: 'GET' })
          .then((response) => {
            response.text().then((data) => {
              dateInfo[i - 1] = data;
              setDateInfo([...dateInfo]);
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  return (
    <div className='container h-full min-h-screen mx-auto px-4 py-14 sm:px-6 xl:px-12'>
      <div className='text-center flex flex-col space-y-2 items-center'>
        <h1 className='text-4xl font-bold tracking-normal sm:text-5xl lg:text-6xl'>Number</h1>
        <p className='max-w-screen-sm text-lg text-gray-600 sm:text-2xl'>Number and its facts</p>
        <input
          type='number'
          className='text-center rounded-md border bg-gray-50 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50'
          placeholder='Enter a number to discover its facts'
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          onKeyUp={(e) => handleOnKeyUp(e)}
        />
        <button
          className='rounded-md border border-blue-500 bg-blue-500 py-2 px-6 text-white transition hover:border-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-4 focus:ring-blue-500 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-blue-500 disabled:hover:bg-blue-500 sm:max-w-max'
          onClick={() => handleSubmit()}>
          Submit
        </button>
      </div>
      <div className='flex flex-col space-y-5 text-center items-center mt-10'>
        {triviaInfo !== '' || mathInfo !== '' || yearInfo !== '' ? (
          <div className='border p-5 rounded-md'>
            <ul className='list-disc px-2 flex flex-col items-center space-y-2'>
              {triviaInfo !== '' ? (
                <li>
                  <span className='underline italic font-bold'>Trivia Fact:</span> {triviaInfo}
                </li>
              ) : null}
              {mathInfo !== '' ? (
                <li>
                  <span className='underline italic font-bold'>Math Fact:</span> {mathInfo}
                </li>
              ) : null}
              {yearInfo !== '' ? (
                <li>
                  <span className='underline italic font-bold'>Year Fact:</span> {yearInfo}
                </li>
              ) : null}
            </ul>
          </div>
        ) : null}

        {monthInfo.filter((info) => info !== '').length > 0 ? (
          <div className='border p-5 rounded-md'>
            <p className='underline italic text-center mb-3 font-bold'>Month Facts:</p>
            <ul className='list-disc px-2 flex flex-col items-center space-y-2'>
              {monthInfo.map((info, index) => (info !== '' ? <li key={index}>{info}</li> : null))}
            </ul>
          </div>
        ) : null}

        {dateInfo.filter((info) => info !== '').length > 0 ? (
          <div className='border p-5 rounded-md'>
            <p className='underline italic text-center mb-3 font-bold'>Date Facts:</p>
            <ul className='list-disc px-2 flex flex-col items-center space-y-2'>
              {dateInfo.map((info, index) => (info !== '' ? <li key={index}>{info}</li> : null))}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default NumberPage;
